import { useEffect, useState } from "react";
import { LocalStore } from "@onchainreps/storage";

export function useLocalStore(): LocalStore | null {
  const [store, setStore] = useState<LocalStore | null>(null);

  useEffect(() => {
    let active = true;
    void LocalStore.open()
      .then((opened) => {
        if (active) setStore(opened);
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, []);

  return store;
}
